import React, { useEffect, useState, Fragment } from "react";
import { Form, Formik } from "formik";
import { toast } from "react-toastify";
import generalSettings from "@apis/generalSettings";
import CardHeader from "@commons/businesscardHeader";
import Fields from "@components/fields";
import Button from "@components/button";
import Wrapper from "@components/wrapper";
import Column from "@components/column";
import styled from "@emotion/styled";
import { StyleSupportFormContainer } from "../style";

const SupportInfo = () => {
  const [existing, setExisting] = useState<any | null>(null);
  const infoFields = ["name", "phoneNo", "alternativePhoneNo", "email", "address", "whatsapp"];
  console.log(existing);

  const fetchSupportInfo = async () => {
    try {
      const data = await generalSettings.getByKey({
        id: "support-info",
        state: "supportInfo",
        showErr: false,
      });
      if (data) {
        setExisting(data);
      }
    } catch (err) {
      console.error("Failed to fetch support info", err);
    }
  };

  useEffect(() => {
    fetchSupportInfo();
  }, []);

  const handleSubmit = async (values: any) => {
    const payload: any = {
      key: "support-info",
      title: "support",
      infos: values,
    };
    try {
      if (existing?.id) {
        await generalSettings
          .update({
            id: existing.id,
            state: "supportInfo",
            data: payload,
          })
          .then(() => {
            toast.success("Support information updated successfully!");
          })
          .catch((err) => {
            console.log(err.message, "err");
            toast.error(err);
          });
      } else {
        await generalSettings.create({
          state: "supportInfo",
          data: payload,
        });
        toast.success("Support information saved successfully!");
      }
      fetchSupportInfo();
    } catch (err) {
      console.error("Failed to save support info", err);
      toast.error("Failed to save support information");
    }
  };

  const formatLabel = (key: string) => {
    // Convert camelCase to Title Case with spaces
    return key
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase())
      .trim();
  };

  const getPlaceholder = (key: string) => {
    const placeholders: { [key: string]: string } = {
      name: "Enter support name",
      phoneNo: "Enter phone number",
      alternativePhoneNo: "Enter alternative phone number",
      email: "Enter email address",
      address: "Enter address",
      whatsapp: "Enter WhatsApp number",
    };
    return placeholders[key] || `Enter ${formatLabel(key).toLowerCase()}`;
  };

  // Create initial values dynamically
  const getInitialValues = () => {
    const initialValues: { [key: string]: string } = {};
    
    // Always initialize all fields with empty strings or existing values
    infoFields.forEach((field) => {
      if (field === "whatsapp") {
        initialValues[field] = existing?.infos?.whatsapp || existing?.infos?.whatapp || "";
      } else {
        initialValues[field] = existing?.infos?.[field] || "";
      }
    });

    return initialValues;
  };

  return (
    <Fragment>
      <Formik
        enableReinitialize
        initialValues={getInitialValues()}
        onSubmit={handleSubmit}
      >
        <Form>
          <CardHeader title="Support Information" />
          <Wrapper>
            <StyleSupportFormContainer>
              {infoFields.map((fieldName) => (
                <Column key={fieldName}>
                  <Fields.Input
                    name={fieldName}
                    label={formatLabel(fieldName)}
                    placeholder={getPlaceholder(fieldName)}
                    styleInput="width:100%"
                  />
                </Column>
              ))}

              <br />
            </StyleSupportFormContainer>
            <Button
              type="submit"
              title={existing ? "Update" : "Save"}
              justify="end"
            />
          </Wrapper>
        </Form>
      </Formik>
    </Fragment>
  );
};

export default SupportInfo;
